import styled from 'styled-components';
import {SIZES} from '@fupa/fupa-uikit';

export const EmbedWrapper = styled.div`
  width: 12rem; // 192px
  min-width: 12rem; // 192px
  height: 8rem; // 128px
  border-radius: ${SIZES['8']};
  cursor: pointer;
  position: relative;
  overflow: hidden;
  margin-right: ${SIZES['16']};
`;
